import * as React from "react";

function SvgPaperPlane(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 18"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M16.65 17.35l2.77-4.91 4-1.88c.84-.42.78-1.09-.13-1.45L1.07.13c-.9-.36-1.32.06-.9 1l7.24 15.13a1.8 1.8 0 002.35.91l3-1.39 1.22 1.26.54.55a1.34 1.34 0 002.13-.24zm-1-6.24a2.89 2.89 0 01-2.84-.55l-8-7.09c-.73-.67-.67-.79.18-.3l10.56 6.3c.85.57.91 1.27.07 1.64z" />
    </svg>
  );
}

const MemoSvgPaperPlane = React.memo(SvgPaperPlane);
export default MemoSvgPaperPlane;
